/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';

import { withIntl } from '../../utilities/localizedUtil';
import { selectors as localeSelectors } from '../redux/ducks/locale';

interface titlePhrase {
  id: string;
  values?: object;
}
interface Props {
  intl?: any;
  locale: string;
  windowTitlePhrase: titlePhrase[];
}

function mapStateToProps(state) {
  return {
    windowTitlePhrase: localeSelectors.getWindowTitlePhrase(state),
  };
}

@withIntl
class WindowTitle extends React.Component<Props, {}> {

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { windowTitlePhrase, intl } = nextProps;

    if (!windowTitlePhrase.length) {
      window.document.title = intl.formatMessage({ id: 'app.backpack.name' });
    } else {
      window.document.title = windowTitlePhrase.map(p => typeof p === 'string' ? p : intl.formatMessage({ id: p.id }, p.values)).join('');
    }
  }

  render() {
    return this.props.children;
  }
}

export default connect(mapStateToProps)(WindowTitle);
